<template lang="pug">
  .inicio-main-dash.payment-quotes.help-center(style="width:100%; align-items: stretch;")
    .inicio-panel.mt-2.border-radius-top(xs12 sm12 md8 lg12)
      .inicio-panel-content
        help-center(:listProducts="products" :search="search" :data="data")
    .inicio-extra
      section
</template>
<script>
/**
 * @component HelpCenter
 * @description Página del Centro de Ayuda (/help-center). Toma los datos del usuario de Vuex y los pasa al
 * componente help-center. Las llamadas a la API (catálogo, búsqueda y tracking) las hace help-center.service
 * contra API_ZONASEGURA, así que la página ya no conoce URLs ni el documento del usuario (el backend lo toma
 * del token).
 */
import HelpCenter from '@/components/help-center/HelpCenter'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      data: {
        nombres: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        telefono: ''
      }
    }
  },
  components: {
    'help-center': HelpCenter
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'basicInfo']),
    products () {
      return this.polizasInfo !== null ? this.polizasInfo.map(p => p.producto.replace(' ', '')) : []
    },
    search () {
      return this.$store.state.user.search
    }
  },
  mounted () {
    const self = this

    this.dataUser()
    if (this.polizasInfo === null) {
      this.$router.push('/inicio')
    }

    self.$root.$emit('npsInactivity', {seccion: 'Centro de Ayuda'})
  },
  methods: {
    /** Copia a `data` el nombre y el teléfono del usuario logueado (acompañan a cada evento de tracking). */
    dataUser () {
      this.data.nombres = this.basicInfo.nombres
      this.data.apellidoPaterno = this.basicInfo.apellidoPaterno
      this.data.apellidoMaterno = this.basicInfo.apellidoMaterno
      this.data.telefono = this.basicInfo.celular
    }
  }
}
</script>
<style scoped>
  @media (max-width: 1024px) {
    .help-center .inicio-extra section{
      margin-top: 0;
      margin-bottom: 30px;
    }
    .help-center .inicio-extra section figure{
      margin: 0;
    }
    .help-center .inicio-extra section figure a{
      display: flex;
      justify-content: center;
    }
  }

  @media (min-width : 1024px) {
    .help-center .inicio-panel{
      margin: 0 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/HelpCenter.vue